import { Badge } from './ui/badge.js';

const LABEL: Record<string, string> = {
  draft: 'Entwurf',
  submitted: 'Eingereicht',
  client_approved: 'Kunde bestätigt',
  client_corrected: 'Kunde hat korrigiert',
  disputed: 'In Klärung',
  pending_review: 'In Prüfung',
  approved: 'Freigegeben',
  rejected: 'Abgelehnt',
  blocked: 'Blockiert',
  terminated: 'Beendet',
  uploaded: 'Hochgeladen',
  expired: 'Abgelaufen',
  pending: 'Pending',
  ceo: 'CEO',
  internal_staff: 'Staff',
  worker: 'Worker',
  client: 'Client',
};

const VARIANT: Record<string, 'default' | 'secondary' | 'outline' | 'success' | 'warning' | 'destructive'> = {
  draft: 'outline',
  submitted: 'warning',
  client_approved: 'secondary',
  client_corrected: 'warning',
  disputed: 'destructive',
  pending_review: 'warning',
  approved: 'success',
  rejected: 'destructive',
  blocked: 'destructive',
  terminated: 'destructive',
  uploaded: 'secondary',
  expired: 'destructive',
  pending: 'outline',
  ceo: 'default',
  internal_staff: 'secondary',
  worker: 'secondary',
  client: 'secondary',
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <Badge variant={VARIANT[status] ?? 'outline'}>{LABEL[status] ?? status}</Badge>
  );
}
